import { Wrapper } from 'lib/noop-wrapper'
import React from 'react'
import Link from 'next/link'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import { isNewVersion } from 'lib/version'

export interface IKoubeiLinkParams {
  id?: string
  anchorId?: 'comment' | ''
  zt?: string
  title?: string
  rel?: string
}

function koubeiLink({
  id,
  zt,
  anchorId,
  title,
  rel,
}: IKoubeiLinkParams): Wrapper {
  return (content) =>
    id ? (
      <React.Fragment>
        <a
          target={'_blank'}
          title={title}
          rel={rel}
          href={`/koubei/${id}${
            zt
              ? `?${serializeObject({
                zt,
              })}`
              : ''
          }${anchorId ? `#${anchorId}` : ''}`}
        >
          {content}
        </a>
        <style jsx>
          {`
            a {
              color: inherit;
            }
          `}
        </style>
      </React.Fragment>
    ) : (
      content
    )
}

export default koubeiLink
